// API Configuration - now uses environment variables
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://www.drivingsales.com/api/';
export const S3_PROD_API = import.meta.env.VITE_S3_PROD_BUCKET || 'drivingsales-prod';
export const S3_DEV_API = import.meta.env.VITE_S3_DEV_BUCKET || 'drivingsales-qa';
export const S3_URL = import.meta.env.VITE_S3_URL || 'https://s3-us-west-2.amazonaws.com/';

export const FRANCHISES = [
    { id: 'acura', label: 'Acura' },
    { id: 'alfa romeo', label: 'Alfa Romeo' },
    { id: 'audi', label: 'Audi' },
    { id: 'bmw', label: 'BMW' },
    { id: 'buick', label: 'Buick' },
    { id: 'candillac', label: 'Candillac' },
    { id: 'chevrolet', label: 'Chevrolet' },
    { id: 'chrysler', label: 'Chrysler' },
    { id: 'dodge', label: 'Dodge' },
    { id: 'fiat', label: 'FIAT' },
    { id: 'ford', label: 'Ford' },
    { id: 'genesys', label: 'Genesys' },
    { id: 'gmc', label: 'GMC' },
    { id: 'honda', label: 'Honda' },
    { id: 'hyundai', label: 'Hyundai' },
    { id: 'infiniti', label: 'Infiniti' },
    { id: 'jaguar', label: 'Jaguar' },
    { id: 'jeep', label: 'Jeep' },
    { id: 'kia', label: 'KIA' },
    { id: 'land rover', label: 'Land Rover' },
    { id: 'lexus', label: 'Lexus' },
    { id: 'lincoln', label: 'Lincoln' },
    { id: 'mazerati', label: 'Mazerati' },
    { id: 'mazda', label: 'Mazda' },
    { id: 'mercedes-benz', label: 'Mercedes-Benz' },
    { id: 'mini', label: 'MINI' },
    { id: 'mitsubishi', label: 'Mitsubishi' },
    { id: 'nissan', label: 'Nissan' },
    { id: 'porsche', label: 'Porsche' },
    { id: 'smart', label: 'Smart' },
    { id: 'subaru', label: 'Subaru' },
    { id: 'toyota', label: 'Toyota' },
    { id: 'volkswagen', label: 'Volkswagen' },
    { id: 'volvo', label: 'Volvo' },
];

export const LICENCES_LIST = [
    {
        id: 'hcm',
        label: 'HCM',
        options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ],
        checks: [
            { label: 'Licenses', value: 'licenses' },
            { label: 'Org chart', value: 'org-chart' },
            { label: 'Library', value: 'library' },
            { label: 'Employees', value: 'employees' },
        ],
    },
    {
        id: 'blogs',
        label: 'Blog',
        options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ],
        checks: [{ label: 'Categories', value: 'categories' }],
    },
    {
        id: 'community',
        label: 'Community',
        options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ],
        checks: [
            { label: 'Followers', value: 'followers' },
            { label: 'Employees', value: 'employees' },
        ],
    },
    {
        id: 'vendor_rating',
        label: 'Vendor Ratings',
        options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ],
        checks: [
            { label: 'All Products', value: 'all-products' },
            { label: 'Grappone CRM', value: 'grappone-crm' },
            { label: 'Grappone Websites', value: 'grappone-websites' },
            { label: 'Automotive DMS', value: 'automotive-dms' },
        ],
    },
    {
        id: 'global_author',
        label: 'Global Author',
        options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ],
        checks: [
            { label: 'Training', value: 'training' },
            { label: 'Programs', value: 'programs' },
            { label: 'ToDo', value: 'todo' },
            { label: 'Documents', value: 'documents' },
            { label: 'Questionaires', value: 'questionaires' },
        ],
    },
    {
        id: 'jobs',
        label: 'Jobs',
        options: [
            { label: 'Yes', value: 'yes' },
            { label: 'No', value: 'no' },
        ],
        checks: [{ label: 'Work With Us', value: 'work-with-us' }],
    },
];

export const HCM_LICENSES = [
    { id: 0, label: 'Training and Development' },
    { id: 1, label: 'Tasks and Projects' },
    { id: 2, label: 'Performance Reviews' },
    { id: 3, label: 'Reports and Records' },
    { id: 4, label: 'Certification Programs' },
    { id: 5, label: 'Career Programs' },
    { id: 6, label: 'Documents' },
    { id: 7, label: 'eSignatures' },
    { id: 8, label: 'Questionaires' },
];

export const HCM_FEATURES = {
    basic: [
        { id: 0, label: 'Basic' },
        { id: 1, label: 'Tasks' },
        { id: 2, label: 'Training' },
    ],
    plus: [
        { id: 0, label: 'Plus' },
        { id: 1, label: 'Tasks' },
        { id: 2, label: 'Training' },
        { id: 3, label: 'Scorecards' },
    ],
    premium: [
        { id: 0, label: 'Premium' },
        { id: 1, label: 'Tasks' },
        { id: 2, label: 'Training' },
        { id: 3, label: 'Scorecards' },
        { id: 4, label: 'Careers' },
        { id: 5, label: 'Certifications' },
        { id: 6, label: 'New Hire Orientation' },
        { id: 7, label: 'Documents' },
        { id: 8, label: 'eSignatures' },
    ],
};

export const COMPANY_FEATURES = [
    { id: 'vendor_ratings', label: 'Products' },
    { id: 'blog', label: 'Blog' },
    { id: 'community', label: 'Community' },
    { id: 'store', label: 'Store' },
    { id: 'hcm', label: 'HCM' },
];

export const FEATURE_OPTIONS = [
    { label: 'Enable', value: 'enable' },
    { label: 'Disable', value: 'disable' },
];

export const VENDOR_CATEGORIES = [
    { shortName: 'DMS', name: 'DMS' },
    { shortName: 'CRM', name: 'CRM - Sales Dept.' },
    { shortName: 'Websites', name: 'Websites' },
    { shortName: 'Inventory', name: 'Inventory Merchandising' },
    { shortName: 'HCM', name: 'Employee Management' },
    { shortName: 'PPC', name: 'SEM - Paid Search' },
    { shortName: 'SEO', name: 'SEO Tools & Services' },
];

export const EXPOSURE_LEVELS = [
    { label: 'Basic', value: 'wiki' },
    { label: 'Plus', value: 'silver' },
    { label: 'Premium', value: 'gold' },
];

export const SHOW_CASES = [
    { value: 'wiki', label: 'Basic' },
    { value: 'silver', label: 'Plus' },
    { value: 'gold', label: 'Premium' },
];
// USA_TIMEZONES
export const TIMEZONES = [
    { id: 0, label: 'UTC-10: Adak', value: 'America/Adak' },
    { id: 1, label: 'UTC-10: Honolulu', value: 'America/Honolulu' },
    { id: 2, label: 'UTC-9: Anchorage', value: 'America/Anchorage' },
    { id: 3, label: 'UTC-9: Juneau', value: 'America/Juneau' },
    { id: 4, label: 'UTC-9: Nome', value: 'America/Nome' },
    { id: 5, label: 'UTC-9: Sitka', value: 'America/Sitka' },
    { id: 6, label: 'UTC-9: Yakutat', value: 'America/Yakutat' },
    { id: 7, label: 'UTC-8: Los Angeles', value: 'America/Los_Angeles' },
    { id: 8, label: 'UTC-8: Metlakatla', value: 'America/Metlakatla' },
    { id: 9, label: 'UTC-7: Boise', value: 'America/Boise' },
    { id: 10, label: 'UTC-7: Denver', value: 'America/Denver' },
    { id: 11, label: 'UTC-7: Phoenix', value: 'America/Phoenix' },
    { id: 12, label: 'UTC-6: Chicago', value: 'America/Chicago' },
    { id: 13, label: 'UTC-6: Menominee', value: 'America/Menominee' },
    { id: 14, label: 'UTC-6: North_Dakota/Beulah', value: 'America/North_Dakota/Beulah' },
    { id: 15, label: 'UTC-6: North_Dakota/Center', value: 'America/North_Dakota/Center' },
    { id: 16, label: 'UTC-6: North_Dakota/New_Salem', value: 'America/North_Dakota/New_Salem' },
    { id: 17, label: 'UTC-5: Detroit', value: 'America/Detroit' },
    { id: 18, label: 'UTC-5: Indiana/Indianapolis', value: 'America/Indiana/Indianapolis' },
    { id: 19, label: 'UTC-5: Indiana/Marengo', value: 'America/Indiana/Marengo' },
    { id: 20, label: 'UTC-5: Indiana/Petersburg', value: 'America/Indiana/Petersburg' },
    { id: 21, label: 'UTC-5: Indiana/Tell City', value: 'America/Indiana/Tell_City' },
    { id: 22, label: 'UTC-5: Indiana/Vevay', value: 'America/Indiana/Vevay' },
    { id: 23, label: 'UTC-5: Indiana/Vincennes', value: 'America/Indiana/Vincennes' },
    { id: 24, label: 'UTC-5: Indiana/Winamac', value: 'America/Indiana/Winamac' },
    { id: 25, label: 'UTC-5: Kentucky/Louisville', value: 'America/Kentucky/Louisville' },
    { id: 26, label: 'UTC-5: Kentucky/Monticello', value: 'America/Kentucky/Monticello' },
    { id: 27, label: 'UTC-5: New York', value: 'America/New_York' },
    { id: 28, label: 'UTC-5: North_Dakota/Beulah', value: 'America/North_Dakota/Beulah' },
    { id: 29, label: 'UTC+0: London', value: 'Europe/London' },
    { id: 30, label: 'UTC+0: Jersey', value: 'Europe/Jersey' },
    { id: 31, label: 'UTC+0: Guernsey', value: 'Europe/Guernsey' },
    { id: 32, label: 'UTC+0: Isle of Man', value: 'Europe/Isle_of_Man' },
    { id: 33, label: 'UTC+0: Dublin', value: 'Europe/Dublin' },
];

export const RATING_STATUS = [null, 'Poor', 'Fair', 'Good', 'Very Good', 'Excellent'];

export const VARIANT_TYPE = { high: 'contained', medium: 'outlined', low: 'text', link: 'text' };

export const LIBRARY_NOTIFICATIONS = [
    { id: 'COMMUNITY', name: 'Community', description: 'Blogs, Forums, Connections...' },
    { id: 'PROGRAM', name: 'Programs', description: 'Careers, Certifications' },
    { id: 'QUESTIONNAIRE', name: 'Questionnaires', description: 'Options here...' },
    { id: 'TASK', name: 'Tasks', description: 'Tasks' },
    { id: 'TODO', name: 'To dos', description: 'Scorecards, Habits, Quotas' },
    { id: 'TRAINING', name: 'Training', description: 'Tracks, Schedules, Courses' },
];

export const INITIAL_NOTIFICATION_SETTINGS = {
    created_at: '',
    data: {
        COMMUNITY: { app: 0, text: 0, email: 0 },
        PROGRAM: { app: 0, text: 0, email: 0 },
        QUESTIONNAIRE: { app: 0, text: 0, email: 0 },
        TASK: { app: 0, text: 0, email: 0 },
        TODO: { app: 0, text: 0, email: 0 },
        TRAINING: { app: 0, text: 0, email: 0 },
    },
    id: 1,
    updated_at: '',
    user_id: 0,
};

export const CONNECTION_MOBILE_TABLIST = [
    { id: 'people', label: 'People', name: 'People' },
    { id: 'companies', label: 'Companies', name: 'Companies' },
    { id: 'received', label: 'Received Requests', name: 'Received Requests' },
    { id: 'sent', label: 'Sent Requests', name: 'Sent Requests' },
];

export const HUMAN_CAPITAL_TAB = [
    { id: 0, label: 'Employees', name: 'employees' },
    { id: 1, label: 'Org', name: 'org' },
    { id: 2, label: 'Library', name: 'library' },
];

export const PRODUCT_REPORT_ROUTES = [
    { name: 'ratings', label: 'Ratings' },
    { name: 'rating-trends', label: 'Rating Trends' },
    { name: 'visibility', label: 'Visibility' },
    // { name: 'category', label: 'Category' },
    { name: 'competition', label: 'Competition' },
    // { name: 'nps', label: 'NPS' },
    { name: 'dealer-satisfaction-award', label: 'DSA Award' },
];

export const BLOG_MOBILE_TABLIST = [
    { id: 'recent', name: 'Recent', label: 'Recent' },
    { id: 'categories', name: 'Categories', label: 'Categories' },
    { id: 'departments', name: 'Departments', label: 'Departments' },
];

export const PROFILE_MOBILE_TABLIST = [
    { id: 0, name: 'activity', label: 'Activity' },
    { id: 1, name: 'about', label: 'About' },
    { id: 2, name: 'blog', label: 'Blog' },
    { id: 3, name: 'connections', label: 'Connections' },
    { id: 4, name: 'recommendations', label: 'Recommendations' },
    { id: 5, name: 'account-admin', label: 'Account Admin' },
    { id: 6, name: 'blog-admin', label: 'Blog Admin' },
    { id: 7, name: 'reports', label: 'Reports' },
];

export const BLOG_MOBILE_TAB = [
    { id: 'drafts', name: 'Drafts', label: 'Drafts' },
    { id: 'published', name: 'Published', label: 'Published' },
    { id: 'category', name: 'Category MGT', label: 'Category MGT' },
];

export const ACCOUNT_ADMIN_MOBILE_TABS = [
    { id: 'account', name: 'account', label: 'Account' },
    { id: 'permission', name: 'permission', label: 'Permissions' },
    { id: 'notifications', name: 'notifications', label: 'Notifications' },
];

export const PRODUCT_REPORT_REVIEWS = [
    { id: 0, name: 'New Reviews' },
    { id: 1, name: 'Avg Ratings' },
    { id: 2, name: 'Recommended %' },
];

export const PRODUCT_REPORT_EXPOSURE = [
    { id: 0, name: 'Impressions' },
    { id: 1, name: 'Views' },
    { id: 2, name: 'Clicks' },
];

export const PRODUCT_REPORT_TREND_TRENDS = [
    { id: 0, name: 'Star rating ave' },
    { id: 1, name: '%recommended ave' },
];

export const PRODUCT_REPORT_TREND_REVIEWS = [
    { id: 0, name: 'Verified' },
    { id: 1, name: 'Dealerships' },
    { id: 2, name: 'Blocked' },
];

export const MEMBER_TYPES = [
    { id: 0, name: 'Dealer Professional' },
    { id: 1, name: 'Vendor' },
    { id: 2, name: 'Manufacturer' },
    { id: 3, name: 'Other' },
];

export const PRODUCT_MOBILE_ADMIN = [
    { id: 'home', name: 'home', label: 'Home' },
    { id: 'all', name: 'all', label: 'All Products' },
    { id: 'reports', name: 'reports', label: 'Reports' },
];

export const BLOG_COMPANY_TABS = [
    { id: 0, name: 'drafts', label: 'Drafts' },
    { id: 1, name: 'published', label: 'Published' },
    { id: 2, name: 'category', label: 'Category MGT' },
];

export const MOBILE_ACCOUNT_ADMIN_TABS = [
    { id: 'default', name: 'default', label: 'Default' },
    { id: 'companies', name: 'companies', label: 'Companies' },
    { id: 'notifications', name: 'notifications', label: 'Notifications' },
    { id: 'password', name: 'password', label: 'Password' },
    { id: 'permissions', name: 'permissions', label: 'Permissions' },
    { id: 'profile-optimization', name: 'profile-optimization', label: 'Profile Optimization' },
];

export const HCM_ADMIN_TABS = [
    { id: 0, name: 'licenses', label: 'Licenses' },
    { id: 1, name: 'orgChart', label: 'Org Chart' },
    { id: 2, name: 'library', label: 'Library' },
    { id: 3, name: 'employees', label: 'Employees' },
    { id: 4, name: 'reports', label: 'Reports' },
];

export const SUPERADMIN_CONTENT_TYPE = [
    { id: 1, name: 'FILE', value: 'file' },
    { id: 2, name: 'COMMENT', value: 'comment' },
    { id: 3, name: 'REVISION', value: 'revision' },
    { id: 4, name: 'PAGE', value: 'page' },
    { id: 5, name: 'VIDEO', value: 'video' },
    { id: 6, name: 'TOPIC', value: 'forums' },
    { id: 7, name: 'POST', value: 'blogs' },
    { id: 8, name: 'COMPANY', value: 'company' },
    { id: 9, name: 'PRODUCT', value: 'products' },
    { id: 10, name: 'RATING', value: 'rating' },
    { id: 11, name: 'CONVERSATION', value: 'conversation' },
];

export const CONTENT_STATUS = [
    { status: 0, title: 'Approved', value: 'approved' },
    { status: 1, title: 'Blocked', value: 'blocked' },
    { status: 2, title: 'Unmoderated', value: 'unmoderated' },
    { status: 3, title: 'Banned', value: 'banned' },
];

export const FEATURED_CONTENT_TYPE = [
    { type: 1, name: 'Post' },
    { type: 2, name: 'Topic' },
    { type: 3, name: 'User' },
    { type: 4, name: 'Company' },
    { type: 5, name: 'Product' },
];

export const TABS_COMPANY_MGT = [
    { id: 'all', name: 'all', label: 'All' },
    { id: 'products', name: 'products', label: 'Products' },
    { id: 'library', name: 'library', label: 'Library' },
    { id: 'blogs', name: 'blogs', label: 'Blogs' },
    { id: 'community', name: 'community', label: 'Community' },
    { id: 'hcm', name: 'hcm', label: 'HCM' },
];

export const FEATURE_CONTENT_TABS = [
    { id: 'all', label: 'All', name: 'all' },
    { id: 'post', label: 'Posts', name: 'post' },
    { id: 'topic', label: 'Topic', name: 'topic' },
    { id: 'user', label: 'Users', name: 'user' },
    { id: 'company', label: 'Companies', name: 'company' },
    { id: 'product', label: 'Products', name: 'product' },
];

export const CONTENT_MGT_TABS = [
    { id: 'all', name: 'all', label: 'All' },
    { id: 'products', name: 'products', label: 'Products' },
    { id: 'blogs', name: 'blogs', label: 'Blogs' },
    { id: 'forums', name: 'forums', label: 'Forums' },
];

export const USER_MGT_TABS = [
    { name: 'all', id: 'all', label: 'All' },
    { name: 'products', id: 'products', label: 'Products' },
    // { name: 'library', id: 'library', label: 'Library' },
    // { name: 'jobs', id: 'jobs', label: 'Jobs' },
    { name: 'blogs', id: 'blogs', label: 'Blogs' },
    // { name: 'community', id: 'community', label: 'Community' },
    { name: 'hcm', id: 'hcm', label: 'HCM' },
];

export const PRODUCT_REPORTS_TABS = [
    { id: 'ratings', name: 'Ratings', label: 'Ratings' },
    { id: 'rating-trends', name: 'Rating Trends', label: 'Rating Trends' },
    { id: 'visibility', name: 'Visibility', label: 'Visibility' },
    // { id: 'category', name: 'Category', label: 'Category' },
    { id: 'competition', name: 'Competition', label: 'Competition' },
    // { id: 'nps', name: 'NPS', label: 'NPS' },
    { id: 'dealer-satisfaction-award', name: 'DSA Award', label: 'DSA Award' },
];

export const DROP_FILE_TYPE = {
    powerpoint: '.ppt, .pptx, .pot, .potx, .odp',
    word: '.doc, .docx',
    pdf: 'application/pdf',
};

export const Habit_Type = {
    month: 'Monthly',
    week: 'Weekly',
    day: 'Daily',
};

export const Unknown_User = {
    id: 0,
    community_user: {
        avatar: '',
        first_name: 'Unknown',
        last_name: 'User',
    },
    profile: { avatar: '' },
};

export const ACTUALS_NUMBER_TYPES = [
    { id: 0, name: 'Dollar' },
    { id: 1, name: 'Number' },
    { id: 2, name: 'Percentage' },
];

export const QUOTA_VALUES = [
    { id: 1, name: 'Quantity' },
    { id: 2, name: 'Percentage' },
    { id: 3, name: 'Task' },
    { id: 4, name: 'Text' },
    { id: 5, name: 'Dollar' },
];

export const QUOTA_TRACKING = [
    { id: 0, name: 'Daily' },
    { id: 1, name: 'Monthly' },
    { id: 2, name: 'Quarterly' },
    { id: 3, name: 'Yearly' },
];

export const QUOTA_FORECASTING = [
    { id: 0, name: 'Average' },
    { id: 1, name: 'Cumulative Average' },
    { id: 2, name: 'Cumulative Total' },
];

export const QUOTA_CACULATIONS = [
    { id: 0, name: 'Month' },
    { id: 1, name: 'Quarter' },
    { id: 2, name: 'Total' },
    { id: 3, name: 'Monthly Average' },
    { id: 4, name: 'Quarterly Average' },
];

export const QUOTA_DIRECTIONS = [
    { id: 1, name: 'Higher is better' },
    { id: 2, name: 'Lower is better' },
];

export const QUOTA_TYPES = {
    1: 'Number',
    2: 'Percentage',
    3: 'Task',
    4: 'Text',
    5: 'Dollar',
};

export const VENDOR_RATING_STATUSES = {
    pending: {
        name: 'Pending',
        value: 'pending',
    },
    blocked: {
        name: 'Blocked',
        value: 'blocked',
    },
    underReview: {
        name: 'Under-review',
        value: 'under-review',
    },
    verified: {
        name: 'Verified',
        value: 'verified',
    },
};

export const COM_BLOG_CATEGORIES_STORAGE_KEY = 'com-blog-categories';
